import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';

type CardAutoloadNoneProps = {
    next: () => void;
};

export default function CardAutoloadNone({ next }: CardAutoloadNoneProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">{t('cardautoload.title')}</h1>
      <p className="pt-3 pb-1 instructions ion-text-center">
        {t('cardautoload.info1')}
      </p>
      <p className="pt-1 pb-1 instructions ion-text-center">
          {t('cardautoload.info2')}
      </p>


      <div className="pt-3 ion-text-center">
        <IonButton className="btn-default btn-wide-80" onClick={() => next()}>
          {t('cardautoload.set')}
        </IonButton>
      </div>
    </>
  );
}
